// extracted by mini-css-extract-plugin
module.exports = {"careerRecommendJobList__jobCardWrapper":"careerRecommendJobList__jobCardWrapper","careerRecommendJobList__pagination":"careerRecommendJobList__pagination"};